import React from 'react';

import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

import { Box, Container, Tab, Tabs } from '@mui/material';

import PageSubheader from '~/components/Common/Elements/PageSubheader';

import useAppNavigation from '~/hooks/useAppNavigation';

import BlockedIdentitiesPanel from './BlockedIdentitiesPanel';
import EmailDomainRulesPanel from './EmailDomainRulesPanel';
import { GHAEmailRulesSection, GHA_EMAIL_RULES_SECTIONS } from './constants';

// GHA-403: the rules that classify a GHA shopper's email at voucher mint: domain rules (consumer,
// hotel or uncertain per domain) and blocked identities (specific people). Shadow mode for now:
// the result is only logged, nothing acts on it.
export default function GHAEmailDomainRulesContainer() {
  const location = useLocation();
  const { push } = useAppNavigation();

  const sectionParam = new URLSearchParams(location.search).get('section');
  const section: GHAEmailRulesSection = GHA_EMAIL_RULES_SECTIONS.includes(sectionParam as GHAEmailRulesSection)
    ? (sectionParam as GHAEmailRulesSection)
    : 'domain-rules';

  // Each tab keeps its own page and filters in the URL, so a switch starts the new tab fresh.
  const handleSectionChange = (next: GHAEmailRulesSection) => {
    push({ search: new URLSearchParams({ section: next }).toString() });
  };

  return (
    <Container>
      <Helmet>
        <title>GHA Email Domain Rules</title>
      </Helmet>
      <PageSubheader title="GHA Email Domain Rules" />
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={section} onChange={(_, next: GHAEmailRulesSection) => handleSectionChange(next)}>
          <Tab label="Domain Rules" value="domain-rules" />
          <Tab label="Blocked Identities" value="blocked-identities" />
        </Tabs>
      </Box>
      {section === 'domain-rules' && <EmailDomainRulesPanel />}
      {section === 'blocked-identities' && <BlockedIdentitiesPanel />}
    </Container>
  );
}
